/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { revokeUserPermissions } from '@/services/organization'
import { useAuth0 } from '@auth0/auth0-react'
import { Button, Flex, Spinner, Stack, useToast } from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'

const RevokePermissions = ({
  onClose,
  permissionId,
  organizationId,
  reloadItems
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const toast = useToast()
  const {
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm()

  const onSubmit = async () => {
    try {
      await revokeUserPermissions({ organizationId, permissionId }, getAccessToken)

      toast({
        title: 'Success',
        description: 'Permission was revoked successfully',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
      })
      onClose()
      reloadItems()
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to revoke permissions. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
      })
    }
  }
  return (
    isSubmitting
      ? <Flex justifyContent="center">
          <Spinner size='xl' />
        </Flex>
      : <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            Are you sure you want to revoke permissions?
          </div>
          <Stack
            direction='row'
            spacing={3}
            align="right"
            justifyContent="flex-end"
          >
            <Button
              onClick={onClose}
              variant="outline"
            >
              Cancel
            </Button>
            <Button
              colorScheme="red"
              type="submit"
            >
              Revoke
            </Button>
          </Stack>
        </form>
  )
}

export default RevokePermissions
